import { render, staticRenderFns } from "./TodoTabNavigation.vue?vue&type=template&id=c0b2cd04&scoped=true&"
import script from "./TodoTabNavigation.vue?vue&type=script&lang=js&"
export * from "./TodoTabNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TodoTabNavigation.vue?vue&type=style&index=0&id=c0b2cd04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b2cd04",
  null
  
)

export default component.exports